<section class="mx-3">
  <div class="page_header">
    <h3 class="m-0 page_header_title" translate>
      @if(dataId == user?.data.id){My Profile}
      @else{Profile}</h3>
  </div>
  <div class="card" style="height: 100vh;">
    <div class="row my-3 mx-2">
      <div class="col-sm-3 col-md-3">
        <div>
          <div class="card text-invert-color">
            <div class="position-relative">
              <div class="position-absolute top-0 end-0">
                <div class="m-2">
                  <input #csvInput hidden="true" type="file" onclick="this.value=null" (change)="csvInputChange($event)"
                    accept="image/png, image/jpeg" />
                  <!-- <button mat-flat-button color="primary" (click)="csvInput.click()">Choose Spreadsheet
                                File (CSV)</button> -->
                  <!-- <mat-icon
                  aria-hidden="false"
                  aria-label="Example home icon"
                  [ngStyle]="{ color: '#3f51b5' }"
                  fontIcon="create"
                ></mat-icon> -->
                  <span class="bg-text-color-blue" (click)="csvInput.click()">
                    <i class="fa-solid fa-pen-to-square"></i>
                  </span>
                </div>
              </div>
              <img #img [src]="imageUrl" (error)="img.src = onerror" class="card-img-top" alt="..." />
              <div class="card-body p-2 bg-profile-navyblue rounded-bottom">
                <div class="card-text text-center text-white">
                  <div>
                    <h4 class="m-0">
                      <strong>{{ employeeprofile?.first_name }}
                        {{ employeeprofile?.last_name }}</strong>
                    </h4>
                  </div>
                  <div class="d-flex justify-content-center align-items-center">
                    <p class="m-0">{{ employeeprofile?.designation_name }}</p>
                    <p class="px-2 mb-1" *ngIf="employeeprofile?.department_name">
                      <i class="fa-solid fa-circle fs-7"></i>
                    </p>
                    <p class="m-0">{{ employeeprofile?.department_name }}</p>
                  </div>
                  <div>
                    <p class="m-0">
                      <span translate>Experience</span>: {{ employeeexperience?.total_expiriance }} Years
                    </p>
                  </div>
                </div>
                <div class="card-text text-white mt-3">
                  <div class="d-flex">
                    <p class="m-0" *ngIf="employeeprofile?.appointment_type">{{employeeprofile?.appointment_type}}</p>
                    <p class="px-2" *ngIf="employeeprofile?.employment_type">
                      <i class="fa-solid fa-circle fs-7"></i>
                    </p>
                    <p class="m-0">{{ employeeprofile?.employment_type }}</p>
                  </div>
                  <div>
                    <p class="m-0">
                      <span translate>ID</span>: {{ employeeprofile?.employee_unique_id }}
                    </p>
                  </div>
                  <div>
                    <p class="m-0">
                      <span translate>Date Of Joining</span>:
                      {{ employeeprofile?.date_of_joining | date }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="">
          <button mat-button class="w-100 button_color" (click)="navigatetoedit()" translate>
            Update Profile
          </button>
        </div>
      </div>
      <div class="col-sm-9 col-md-9">
        <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
          <mat-tab label="{{Personal | translatepipe}}">
            <div class="mt-4">
              <div class="card">
                <div class="row m-0 py-3">
                  <div class="col-md-6 col-sm-12 line-height-10">
                    <div>
                      <p>
                        <span translate>Gender</span> : <span class="text_color_light">{{ employeeprofile?.gender }}</span>
                      </p>
                    </div>
                    <div>
                      <p>
                        <span translate>Date of Birth</span> : <span class="text_color_light">{{ employeeprofile?.date_of_birth | date
                          }}</span>
                      </p>
                    </div>
                    <div>
                      <p>
                        <span translate>Religion</span> : <span class="text_color_light">{{ employeeprofile?.religion }}</span>
                      </p>
                    </div>
                    <div>
                      <p class="m-0">
                        <span translate>Caste</span> : <span class="text_color_light">{{ employeeprofile?.caste }}</span>
                      </p>
                    </div>
                    <!-- <div>
                  <p>
                   Sub Caste : </strong
                    ><span>{{ employeeprofile?.sub_caste }}</span>
                  </p>
                </div> -->
                  </div>
                  <div class="col-md-6 col-sm-12 line-height-10">
                    <div>
                      <p>
                        <span translate>Aadhar</span> : <span class="text_color_light">{{ employeeprofile?.adhar_number }}</span>
                      </p>
                    </div>
                    <div>
                      <p class="m-0">
                        <span translate>PAN</span> : <span class="text_color_light">{{ employeeprofile?.pan_number }}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card mt-2">
                <div class="m-0 row py-3 line-height-10">
                  <div>
                    <p>
                      <span translate>Contact</span> : <span class="text_color_light">{{ employeeData?.phone_number }}</span>
                    </p>
                  </div>
                  <div>
                    <p>
                      <span translate>Alternate Contact</span> : <span class="text_color_light">{{ employeeprofile?.alternate_mobile_number
                        }}</span>
                    </p>
                  </div>
                  <div>
                    <p class="m-0">
                      <span translate>Email Id</span> : <span class="text_color_light">{{ employeeData?.professional_email }}</span>
                    </p>
                  </div>
                </div>
              </div>
              <div class="card mt-2" *ngIf="employeeaddress.length > 0">
                <div class="m-0 row py-3">
                  <p class="m-0" translate> Present Address :</p>
                  <p><span class="text_color_light">{{ employeeaddress[0]?.address_line1 }},
                      {{ employeeaddress[0]?.address_line2 }},
                      {{ employeeaddress[0]?.city }},
                      {{ employeeaddress[0]?.state_name }},
                      {{ employeeaddress[0]?.country_name }},
                      {{ employeeaddress[0]?.pincode }}</span>
                  </p>
                  <p class="m-0" *ngIf="employeeaddress.length >= 2 && employeeaddress[1]" translate> Permanent Address : </p>
                  <p class="m-0"><span class="text_color_light">{{ employeeaddress[1]?.address_line1 }},
                      {{ employeeaddress[1]?.address_line2 }},
                      {{ employeeaddress[1]?.city }},
                      {{ employeeaddress[1]?.state_name }},
                      {{ employeeaddress[1]?.country_name }},
                      {{ employeeaddress[1]?.pincode }}</span>
                  </p>
                </div>
              </div>
            </div>
          </mat-tab>
          <mat-tab label="{{Educations | translatepipe}}">
            <div class="mt-4">
              <div *ngIf="experience_details?.length > 0">
                <div class="">
                  <h4 class="m-0" translate>Experience</h4>
                </div>
              </div>
              <div class="row m-0">
                <div class="col-md-6 col-sm-12 mb-3 pe-2 p-0" *ngFor="let experience of experience_details">
                  <div class="card">
                    <div class="card-body p-2 p-2">
                      <div class="line-height-10">
                        <h4 class="m-0 card-title">{{ experience?.designation }}</h4>
                        <p class="fs-10 card-subtitle mb-2 text-muted">{{ experience?.start_date | date }} -
                          {{ experience?.end_date | date}}</p>
                      </div>
                      <div class="card-text">
                        <div class="line-height-15">
                          <p class="m-0">{{ experience?.organization_name }}</p>
                          <small class="text-muted">{{experience?.location}}</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="employeeeducation?.length > 0">
                <div class="">
                  <h4 class="m-0" translate>Education</h4>
                </div>
                <div class="row m-0">
                  <div class="col-md-6 col-sm-12 mb-3 pe-2 p-0" *ngFor="let education of employeeeducation">
                    <div class="card">
                      <div class="card-body p-2">
                        <div class="line-height-10">
                          <h4 class="m-0 card-title">{{ education?.qualification }}</h4>
                          <p class="fs-10 card-subtitle mb-2 text-muted">{{ education?.start_year | date }} -
                            {{ education?.end_year | date}}</p>
                        </div>
                        <div class="card-text">
                          <div>
                            <p class="m-0">
                              <span translate>Specialization</span> :
                              <span class="text_color_light">{{ education?.course_name }}</span>
                            </p>
                          </div>
                          <div>
                            <p class="m-0">
                              <span translate>Marks</span> : <span class="text_color_light">{{ education?.percentage }}</span>
                            </p>
                          </div>
                          <!-- <div>
                            <p class="m-0">
                              Year of Pass : <span>{{ education?.end_year | date  }}</span>
                            </p>
                          </div> -->
                          <div>
                            <p class="m-0">
                              <span translate>College Name & Address</span> :
                              <span class="text_color_light">{{ education?.university_name }}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mat-tab>
          <mat-tab label="{{Achievements | translatepipe}}">
            <div class="mt-4">
              <div *ngIf="research_details?.length > 0">
                <!-- <div class="">
                  <h4 class="m-0">Achivements</h4>
                </div> -->
                <div class="row m-0">
                  <div class="col-md-6 col-sm-12 mb-3 pe-2 p-0" *ngFor="let research of research_details">
                    <div class="card">
                      <div class="card-body line-height-15 p-2">
                        <p class="m-0 fs-10 card-subtitle mb-2 text-muted">{{ research?.scholarly_work_type_name }}
                          <span *ngIf="research?.activity_type_name"> - {{research?.activity_type_name}}</span></p>
                        <p class="card-title m-0">{{ research?.title }}</p>
                        <p class="fs-10 mb-1 card-subtitle text-muted">{{ research?.platform_name }} - {{ research?.year
                          | date}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mat-tab>
          <mat-tab label="{{Salarys | translatepipe}}">
            <div class="mt-4">
              <div *ngIf="employeesalary" class="mb-3">
                <div class="">
                  <h4 class="m-0" translate>Bank Details</h4>
                </div>
                <div class="row m-0">
                  <div class="col-md-6 col-sm-12 mb-3 pe-2 p-0">
                    <div class="card">
                      <div class="card-body p-2">
                        <div class="line-height-15">
                          <p class="m-0 fs-10 card-subtitle text-muted" translate>credit to bank </p>
                          <p class="m-0 card-title">A/C {{ employeesalary?.bank_account_number }}</p>
                          <p class="fs-10 m-0 card-subtitle text-muted">{{ employeesalary?.bank_name }} - {{
                            employeesalary?.bank_branch_name }}</p>
                          <p class="m-0 fs-10 card-subtitle text-muted">{{ employeesalary?.bank_ifsc_code ?
                            employeesalary?.bank_ifsc_code : '-' }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="employeesalary" class="mb-3">
              <div class="">
                <h4 class="m-0" translate>Salary Details</h4>
              </div>
              <div class="row m-0">
                <div class="col-md-6 col-sm-12 mb-3 pe-2 p-0">
                  <div class="card">
                    <div class="card-body p-2">
                      <p class="m-0 fs-10 card-subtitle text-muted" translate>Pay Scale </p>
                      <div class="card-text">
                        <div>
                          <p class="m-0">
                            <span translate>Gross</span> :
                            <span class="text_color_light">{{ employeesalary?.gross_pay_per_month }}</span>
                          </p>
                        </div>
                        <div>
                          <p class="m-0">
                            <span translate>Basic</span> : <span class="text_color_light">{{ employeesalary?.basic_pay }}</span>
                          </p>
                        </div>
                        <div>
                          <p class="m-0">
                            <span translate>HRA</span> : <span class="text_color_light">{{ employeesalary?.hra_in_rupees }}</span>
                          </p>
                        </div>
                        <div>
                          <p class="m-0">
                            <span translate>Other Allowances</span> :
                            <span class="text_color_light">{{ employeesalary?.other_allowances }}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="employeesalary">
              <div class="">
                <h4 class="m-0" translate>Other Details</h4>
              </div>
              <div class="row m-0">
                <div class="col-md-6 col-sm-12 mb-3 pe-2 p-0">
                  <div class="card">
                    <div class="card-body p-2">
                      <div class="card-text">
                        <div>
                          <p class="m-0">
                            <span translate>PF ID Number</span> : <span class="text_color_light">{{ employeesalary?.pf_number }}</span>
                          </p>
                        </div>
                        <div>
                          <p class="m-0">
                            <span translate>ESI Number</span> : <span class="text_color_light">{{ employeesalary?.esi_number }}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- </div> -->
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </div>
</section>